var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_393_23712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1166 4.54419C14.4691 4.19181 14.6671 3.71384 14.6672 3.21543C14.6673 2.71702 14.4693 2.239 14.1169 1.88652C13.7646 1.53405 13.2866 1.336 12.7882 1.33594C12.2898 1.33587 11.8117 1.53381 11.4593 1.88619L2.56194 10.7855C2.40715 10.9399 2.29268 11.1299 2.22861 11.3389L1.34794 14.2402C1.33071 14.2978 1.32941 14.3591 1.34417 14.4174C1.35894 14.4758 1.38922 14.529 1.4318 14.5715C1.47439 14.614 1.52769 14.6442 1.58605 14.6589C1.6444 14.6736 1.70565 14.6722 1.76327 14.6549L4.66527 13.7749C4.87405 13.7114 5.06406 13.5976 5.21861 13.4435L14.1166 4.54419Z",
    stroke: "#296BCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3.33594L12.6667 6.0026",
    stroke: "#296BCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_393_23712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b903b530db9b0185bc1184d52f22b0f0.svg";
export { ForwardRef as ReactComponent };